module.exports = __webpack_public_path__ + "img/DIF.d9df77c2.png";